
import Vue from 'vue'
import CommonCMSPage from '../../common/cms/CommonCMSPage.vue'

export default Vue.extend({
  name: 'WorkspaceVisualizationPage',
  extends: CommonCMSPage,
})
